import React, {useEffect, useRef, useState} from "react";
import Empty from "../empty/Empty";
import {getColumnClass, ListColumnType, ListHeader, ListProps, ListPropsForUser} from "./List.props";
import "./style.css";

export default function List(props: ListProps<any> | ListPropsForUser<any>) {
    const [items, setItems] = React.useState<any[]>([]);
    const [isAllCheckBoxChecked, setIsAllCheckBoxChecked] = useState<boolean>(false);
    const prevCheckedStateRef = useRef(items.map(item => item.checked));

    useEffect(() => {
        setItems(props.items);
    }, [props.items]);

    useEffect(() => {
        const prevCheckedState = prevCheckedStateRef.current;
        const isChanged = items.some((item, index) => {
            return item.checked !== prevCheckedState[index];
        });

        if (isChanged) {
            setIsAllCheckBoxChecked(items.every(item => item.checked));
            prevCheckedStateRef.current = items.map(item => item.checked);

            if (props.onCheckedChange.toString().split(" ")[0] === "users") {
                props.onCheckedChange(items.filter(item => item.checked));
            } else {
                props.onCheckedChange(items.filter(item => item.checked).map(item => item.seq));
            }
        }
    }, [items]);

    const handleAllCheckboxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        setItems(prevState => {
            return prevState.map(item => {
                item.checked = event.target.checked;
                return item;
            });
        });

        setIsAllCheckBoxChecked(event.target.checked);
    }

    const handleCheckboxClick = (seq: number, event: React.ChangeEvent<HTMLInputElement>) => {
        setItems(prevState => {
            return prevState.map(item => {
                if (item.seq === seq) {
                    item.checked = event.target.checked;
                }

                return item;
            });
        });
    }

    const handleButtonClick = (header: ListHeader, item: any) => {
        if (Array.isArray(header.key)) {
            header.button!.onClick(...header.key.map(key => item[key]));
            return;
        }

        if (typeof header.key === "string" && 0 < header.key.length) {
            header.button!.onClick(item.seq, item[header.key]);
            return;
        }

        header.button!.onClick(item.seq);
    }

    const convertBlanks = (title: string) => {
        return title.replace(/ /g, "\u00a0");
    }

    return (
        <>
            <div className="common-list-wrap">
                {
                    0 < props.headers.length && (
                        <>
                            <table>
                                <thead>
                                <tr>
                                    {
                                        props.headers.map((header, index) => {
                                            return (
                                                <th key={index} className={getColumnClass(header.type)}>
                                                    {
                                                        header.type === ListColumnType.CHECK_BOX
                                                            ? <input
                                                                type="checkbox"
                                                                checked={isAllCheckBoxChecked}
                                                                onChange={handleAllCheckboxClick}
                                                            />
                                                            : <>
                                                                {header.name}
                                                            </>
                                                    }
                                                </th>
                                            );
                                        })
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    items.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                {
                                                    props.headers.map((header, index) => {
                                                        if (header.type === ListColumnType.BUTTON
                                                            || header.type === ListColumnType.TOGGLE_BUTTON) {

                                                            if (header.button === undefined) {
                                                                return <td key={index}></td>;
                                                            }

                                                            return (
                                                                <td key={index} className={getColumnClass(header.type)}>
                                                                    <button
                                                                        className={`
                                                                                ${
                                                                            header.type === ListColumnType.BUTTON
                                                                                ? "box-button "
                                                                                : "toggle-button "
                                                                        }
                                                                                ${
                                                                            header.type === ListColumnType.TOGGLE_BUTTON
                                                                                ? item[header.key]
                                                                                    ? "toggle-active"
                                                                                    : ""
                                                                                : ""
                                                                        }
                                                                            `}
                                                                        onClick={() => handleButtonClick(header, item)}
                                                                    >
                                                                        {
                                                                            header.type === ListColumnType.BUTTON
                                                                                ? <>{header.button!.name}</>
                                                                                : <div className="toggle"/>
                                                                        }
                                                                    </button>
                                                                </td>
                                                            );
                                                        }

                                                        return (
                                                            <td
                                                                key={index}
                                                                className={getColumnClass(header.type)}
                                                                style={
                                                                    header.type === ListColumnType.STATUS
                                                                        ? header.getCellStyle === undefined
                                                                            ? {}
                                                                            : header.getCellStyle(item[header.key])
                                                                        : {}
                                                                }
                                                            >
                                                                {
                                                                    header.type === ListColumnType.CHECK_BOX
                                                                        ? <input
                                                                            type="checkbox"
                                                                            checked={item.checked || false}
                                                                            onChange={(event) => handleCheckboxClick(item.seq, event)}
                                                                        />
                                                                        : <>
                                                                            {
                                                                                header.paymentType
                                                                                && <span className="payment-type">
                                                                                    {header.paymentType(item[header.key[1]])}
                                                                                </span>
                                                                            }
                                                                            <span>
                                                                                {
                                                                                    header.convertToString
                                                                                        ? Array.isArray(header.key)
                                                                                            ? header.convertToString(item[header.key[0]], item[header.key[1]])
                                                                                            : header.convertToString(item[header.key])
                                                                                        : header.type === ListColumnType.LONG_TEXT ? convertBlanks(item[header.key]) : item[header.key]
                                                                                }
                                                                            </span>
                                                                        </>
                                                                }
                                                            </td>
                                                        );
                                                    })
                                                }
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                            {items.length === 0 && <Empty {...props.emptyProps}/>}
                        </>
                    )
                }
            </div>
        </>
    );
}